






























































































































































import {
  computed,
  defineComponent,
  Ref,
  ref,
  nextTick,
} from "@vue/composition-api";
import DrawMap from "@/components/BaseMap.vue";
import Navigation from "./components/Navigation.vue";
import StatisticsInfo from "./components/StatisticsInfo.vue";
import CityIndex from "./components/CityIndex.vue";
import { useMapLayer, useMapCenter } from "./compositions/useMapBaseInfo";
import {
  useQuickSearch,
  useBack,
  useClaimLand,
} from "./compositions/useBusiness";
import { useDrawing } from "./compositions/useDrawing";
import { GraphicInfo } from "@tuliu/base-map";
import { PAGE_TYPE } from "@/constants/pageType";
import { DRAW_MODEL } from "@/constants/drawModel";
import { eventHub } from "@/utils/eventHub";
import { useOnRefresh } from "./compositions/useAPPCallJS";
import { LatLngTuple } from "@tuliu/leaflet";
import _get from "lodash/get";
import { useDrawStore } from "@/store/draw";
import { storeToRefs } from "pinia";
import { useMainStore } from "@/store/main";
import { JSCallAPP } from "@/utils/interactive";
import { CityItem } from "@/api/land";
const active_color = "#FFEF00 ";
const active_weight = 5;
const default_color = "#0097FF";
const default_weight = 2;

export default defineComponent({
  components: {
    DrawMap,
    Navigation,
    StatisticsInfo,
    CityIndex,
  },
  setup() {
    const mainStore = useMainStore();
    const store = useDrawStore();

    const { graphicInfoList: sGraphicInfoList } = storeToRefs(store);

    const graphicInfoList = sGraphicInfoList as Ref<GraphicInfo[]>;

    // 地图实例
    const mapRef = ref<typeof DrawMap | null>(null);

    const { mapZoom, ...mapCenterRest } = useMapCenter(mapRef);

    // 刷新地图
    const rerenderMap = (opt?: {
      selectedGraphicId?: number | number[];
      callback?: () => void;
    }) => {
      const { selectedGraphicId, callback } = opt || {};

      setTimeout(() => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (mapRef.value as any).toGraphicCenter(selectedGraphicId);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (mapRef.value as any).forceUpdateLengthAndAreaInfo();

        callback && callback();
      }, 42);
    };

    eventHub.$on(
      "rerender-map",
      (opt?: {
        selectedGraphicId?: number | number[];
        callback?: () => void;
      }) => {
        rerenderMap(opt);
      }
    );

    const handleUpdateMapCenter = (newMapCenter: LatLngTuple) => {
      store.mapCenter = newMapCenter;
    };

    const handleMapPolygonClick = (id: number) => {
      if (
        store.drawModel !== DRAW_MODEL.create &&
        store.drawModel !== DRAW_MODEL.update &&
        store.drawModel !== DRAW_MODEL.pureRead
      ) {
        eventHub.$emit("set-active-graphic", id);
      }

      eventHub.$emit("map-polygon-click", id);
    };

    const handleTitleClick = (id: number) => {
      eventHub.$emit("map-title-click", id);
    };

    // 设置当前选中的图形
    eventHub.$on("set-active-graphic", (id: number | number[]) => {
      nextTick(() => {
        const idList = Array.isArray(id) ? id : [id];
        graphicInfoList.value.forEach((g) => {
          if (idList.includes(g.id)) {
            g.themeColor = active_color;
            g.weight = active_weight;
          } else {
            g.themeColor = _get(g, "extInfo.themeColor", default_color);
            g.weight = _get(g, "extInfo.weight", default_weight);
          }
        });
        graphicInfoList.value = [...graphicInfoList.value];

        rerenderMap({
          selectedGraphicId: idList,
        });
      });
    });

    const handleNativeMapClick = () => {
      if (store.pageType === PAGE_TYPE.home) {
        JSCallAPP({
          method: "map_click",
        });
      }
    };

    // APP 回调页面刷新事件
    useOnRefresh(() => {
      location.reload();
    });

    // 选择城市
    const cityPopup = ref(false);
    const hanldeCity = () => {
      cityPopup.value = true;
      console.log("--");
    };
    const handleChooseCity = (item: CityItem) => {
      cityPopup.value = false;
      mainStore.userLocationCity = item.name;
      store.mapCenter = [+item.latitude, +item.longitude];
      if ((document.querySelector(".base-map-poi-input") as any).value) {
        (document.querySelector(".base-map-poi-input") as any).value = "";
        (document.querySelector(".base-map-poi-input") as any).dispatchEvent(
          new CustomEvent("input")
        );
      }
    };

    return {
      cityPopup,
      handleChooseCity,
      hanldeCity,
      onlyRead: computed(() => {
        return store.drawModel === DRAW_MODEL.pureRead;
      }),
      mainStore,
      store,
      mapZoom,
      handleTitleClick,
      DRAW_MODEL,
      handleMapPolygonClick,
      handleUpdateMapCenter,
      PAGE_TYPE,
      graphicInfoList,
      mapRef,
      handleNativeMapClick,
      ...mapCenterRest,
      ...useMapLayer(),
      ...useDrawing(),
      ...useClaimLand(),
      ...useQuickSearch(),
      ...useBack(),
    };
  },
});
